module.exports = __webpack_public_path__ + "media/images/icons/smp_access-6965442e9a10936451af9f0efc7e6fd5.svg";